const styles = {
  text: {
    "&:first-letter": { textTransform: "capitalize" },
  },
}
export default styles
